export default "__VITE_ASSET__DBxQV0qP__"